module.exports = __webpack_public_path__ + "c597022bce4b0fb4f5adb814a5b64047.MP3";